import RotatingIcon from "../components/icons/RotatingIcon";
import JumpingIcon from "../components/icons/JumpingIcon";
import { FaReact } from "react-icons/fa";
import { FaMobileAlt } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { TbBrandTypescript } from "react-icons/tb";
import { BsFiletypeCss } from "react-icons/bs";
import { FaCode } from "react-icons/fa6";
import { MdDataObject } from "react-icons/md";
import { DiScrum } from "react-icons/di";

export const topics = {
  'react': {
    title: 'React Questions',
    description: 'Test your React knowledge: hooks, state, effects, context, performance, patterns',
    icon: <RotatingIcon size={50} icon={FaReact} />,
    path: '/react',
    color: 'from-blue-500 to-cyan-500',
  },
  'react-native': {
    title: 'React Native Questions',
    description: 'Mobile development with React Native: components, navigation, performance, platform APIs',
    icon: <JumpingIcon size={50} icon={FaMobileAlt} />,
    path: '/react-native',
    color: 'from-cyan-500 to-teal-500',
  },
  'javascript': {
    title: 'JavaScript Questions',
    description: 'Core JS: scopes, closures, async, types, DOM, patterns, performance',
    icon: <JumpingIcon size={50} icon={IoLogoJavascript} />,
    path: '/javascript',
    color: 'from-yellow-500 to-orange-500',
  },
  'typescript': {
    title: 'TypeScript Questions',
    description: 'Types, generics, unions, narrowing, utility types, config, best practices',
    icon: <JumpingIcon size={50} icon={TbBrandTypescript} />,
    path: '/typescript',
    color: 'from-teal-600 to-cyan-600',
  },
  'css': {
    title: 'CSS Questions',
    description: 'Master CSS concepts including layouts, animations, preprocessors, and modern CSS features',
    icon: <JumpingIcon size={50} icon={BsFiletypeCss} />,
    path: '/css',
    color: 'from-orange-500 to-amber-500',
  },
  'oop': {
    title: 'OOP Questions',
    description: 'Object-oriented principles: encapsulation, inheritance, polymorphism, SOLID, design patterns',
    icon: <RotatingIcon size={50} icon={MdDataObject} />,
    path: '/oop',
    color: 'from-green-600 to-emerald-600',
  },
  'live-coding': {
    title: 'Live Coding Questions',
    description: 'Practice coding problems with constraints and communication focus',
    icon: <JumpingIcon size={50} icon={FaCode} />,
    path: '/live-coding',
    color: 'from-emerald-600 to-teal-600',
  },
  'scrum': {
    title: 'Scrum Questions',
    description: 'Agile and Scrum rituals, roles, artifacts, metrics, and best practices',
    icon: <JumpingIcon size={50} icon={DiScrum} />,
    path: '/scrum',
    color: 'from-orange-600 to-amber-600',
  },
};
